// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar_toolbar__4-VCQ"};